// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadCalendarFileRequestModel from '../../model/download-calendar-file-request-model';
import DownloadCalendarFileRequestDTO from '../dto/download-calendar-file-request-dto';
import dtoSchema from '../schemas/download-calendar-file-request-schema';

export default abstract class DownloadCalendarFileRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadCalendarFileRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.language = data.language;
      this.eventPartyRoleId = data.eventPartyRoleId;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  language?: string;
  /**
  * @type {uuid}
  */
  eventPartyRoleId?: string;

  static toModel(dto: DeepPartial<DownloadCalendarFileRequestDTO>): DownloadCalendarFileRequestModel;
  static toModel(dto: DeepPartial<DownloadCalendarFileRequestDTO> | undefined | null): DownloadCalendarFileRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadCalendarFileRequestDTO> | undefined | null): DownloadCalendarFileRequestModel | undefined {
    return dto ? new DownloadCalendarFileRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadCalendarFileRequestModel> | DownloadCalendarFileRequestModel): DownloadCalendarFileRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      language: unwrapped.language,
      eventPartyRoleId: unwrapped.eventPartyRoleId,
    } as DownloadCalendarFileRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadCalendarFileRequestModel, can not map to DownloadCalendarFileRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
